import { ADMIN_PAGES } from '../config/permissions';

function getFirstAdminPage(store) {
    const page = ADMIN_PAGES.find(item => store.getters['can'](item.permission));
    return page ? page.path : null;
}

// Returns null when the route is allowed, otherwise the location to redirect to.
// Before the user data is loaded every route is allowed, App.vue checks it again after loading.
export function getAccessRedirect(route, store) {
    const meta = route.meta || {};
    if (!meta.permission && !meta.adminIndex) return null;

    const authStatuses = store.getters['getAuthStatuses'];
    if (!authStatuses.isLoggedIn || !authStatuses.initialDataLoaded) return null;

    // "/admin" opens the first tab the user has access to
    if (meta.adminIndex) return getFirstAdminPage(store) || '/';

    if (store.getters['can'](meta.permission)) return null;

    if (meta.admin) return getFirstAdminPage(store) || '/';

    return '/';
}

export function setupAccessGuard(router, store) {
    router.beforeEach(to => {
        const redirect = getAccessRedirect(to, store);
        if (!redirect || redirect == to.path) return true;

        // The admin index is a plain redirect, not a denied page
        if (!to.meta.adminIndex || redirect == '/') {
            store.dispatch('showNotification', {
                type: 'warning',
                text: 'You do not have access to this page'
            });
        }
        return redirect;
    });
}
